import {
  type ConfigOf,
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";
import { pathSegmentIdValidator } from "@p0security/shared/install/validators";

export const CloudflareComponents = InstallSpec({
  scim: ItemComponent({
    type: "string",
    label: "Role management",
    description: "Allow P0 to manage Cloudflare policies for your users",
    maturity: "preview",
    // The account ID is part of the SCIM API URL
    validator: pathSegmentIdValidator,
    schema: {
      scimToken: Element({
        type: "encrypted",
        label: "SCIM API token",
        description:
          "Enter a Cloudflare API token with 'Account SCIM Provisioning' permissions",
      }),
    },
  }),
});

export type CloudflareComponents = typeof CloudflareComponents;
export type CloudflareIntegration = ConfigOf<CloudflareComponents>;
